module.exports = __webpack_public_path__ + "static/media/IoW25-Scotland-IndependentBottler.4ca3ae19.svg";